import gql from "graphql-tag";

export const NOMINEE_CREATE_REFERRAL_CODE = gql`
  mutation NomineeCreateReferralCode($firstName: String!, $lastName: String!) {
    createDiscountCode(firstName: $firstName, lastName: $lastName) {
      feedback
    }
  }
`;
